import React, {useState} from "react";
import {Link} from "react-router-dom";
// reactstrap components
import {
    Button,
    Col,
    Container,
    Nav,
    Navbar,
    NavbarBrand,
    NavItem,
    NavLink,
    Row,
    UncontrolledCollapse
} from "reactstrap";
import LocalizedStrings from "react-localization";
import {common_strings} from "../../translations/common_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import LanguagePanel from "../utils/LanguagePanel";
import {useObservable} from "../utils/observable/observableHook";
import {localeService} from "../utils/observable/services";

let commonStrings = new LocalizedStrings(common_strings);

const AdminNavbar = () => {
    const locale = useObservable(localeService.locale);
    const [loc, setLoc] = useState(locale);

    localize();

    return (
        <>
            <Navbar
                className="navbar-top navbar-horizontal navbar-dark"
                expand="md"
            >
                <Container className="px-4">
                    <NavbarBrand to="/" tag={Link}>
                        <img alt="..." src={require("assets/img/brand/open-white-logo.png")}/>
                    </NavbarBrand>

                    <button className="navbar-toggler" id="navbar-collapse-main">
                        <span className="navbar-toggler-icon"/>
                    </button>

                    <UncontrolledCollapse navbar toggler="#navbar-collapse-main">
                        <div className="navbar-collapse-header d-md-none">
                            <Row>
                                <Col className="collapse-brand" xs="6">
                                    <Link to="/">
                                        <img
                                            alt="..."
                                            src={require("assets/img/brand/open-logo-gray.png")}
                                        />
                                    </Link>
                                </Col>
                                <Col className="collapse-close" xs="6">
                                    <button
                                        className="navbar-toggler"
                                        id="navbar-collapse-main"
                                    >
                                        <span/>
                                        <span/>
                                    </button>
                                </Col>
                            </Row>
                        </div>
                        <Nav className="ml-auto" navbar>
                            {/*<NavItem>*/}
                            {/*  <NavLink className="nav-link-icon" to="/" tag={Link}>*/}
                            {/*    <i className="ni ni-planet" />*/}
                            {/*    <span className="nav-link-inner--text">Dashboard</span>*/}
                            {/*  </NavLink>*/}
                            {/*</NavItem>*/}
                            <NavItem>
                                <NavLink
                                    className="nav-link-icon"
                                    to="/auth/register"
                                    tag={Link}
                                >
                                    <i className="ni ni-circle-08"/>
                                        <span className="nav-link-inner--text">{commonStrings.register}</span>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className="nav-link-icon"
                                    to="/auth/login"
                                    tag={Link}
                                >
                                    <i className="ni ni-key-25"/>
                                    <span className="nav-link-inner--text">{commonStrings.login}</span>
                                </NavLink>
                            </NavItem>
                            {/*<NavItem>*/}
                            {/*  <NavLink*/}
                            {/*    className="nav-link-icon"*/}
                            {/*    to="/admin/user-profile"*/}
                            {/*    tag={Link}*/}
                            {/*  >*/}
                            {/*    <i className="ni ni-single-02" />*/}
                            {/*    <span className="nav-link-inner--text">Profile</span>*/}
                            {/*  </NavLink>*/}
                            {/*</NavItem>*/}
                        </Nav>
                    </UncontrolledCollapse>
                </Container>
            </Navbar>
        </>
    );

    function localize() {
        commonStrings.setLanguage(locale);
        // studentStrings.setLanguage(loc);
        // resourceStrings.setLanguage(loc);
        // alertStrings.setLanguage(loc);
    }

};

export default AdminNavbar;
